export default "/images/ic_favorite_selected.svg?a8993c272e71ea789cfe8c0e281e250a";